import React, { useEffect, useState } from "react";
import { Button, Popover, Typography, Box, Tooltip } from "@mui/material";
import AssistantIcon from "@mui/icons-material/Assistant";
import "./ChatPopup.css"; // Import your CSS file for styling
import CloseIcon from "@mui/icons-material/Close";
import { CHAT_URL } from "../../config";
import ChatBot from "../ChatBot/ChatBot";
import { TITLES, UI_TEXT } from "../../constants";
import { useTranslation } from "react-i18next";

export default function ChatPopup() {
	const [chatVisible, setChatVisible] = useState(false);
	const [hoverVisible, setHoverVisible] = useState(false);
	const [chatUrl, setChatUrl] = useState(CHAT_URL);
	const {t} = useTranslation();
	//  const [isSticky, setIsSticky] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setHoverVisible(true);
		}, 1000); // Show the hover after 2 seconds

		setTimeout(() => {
			setHoverVisible(false);
		}, 5000); // Hide the hover after 5 seconds
	}, []);

	const handleChatOpen = () => {
		const newVisible = !chatVisible;
		setChatVisible(newVisible);
		if (newVisible) {
			// Refresh iframe URL by adding timestamp
			setChatUrl(`${CHAT_URL}?t=${Date.now()}`);
		}
	};

	useEffect(() => {
		if (chatVisible) {
			setHoverVisible(false);
		}
	}, [chatVisible]);


	return (
		<div>
			<div
				className="assistant-icon"
				onClick={handleChatOpen}
				onMouseEnter={() => {
					chatVisible ? setHoverVisible(false) : setHoverVisible(true);
				}}
				onMouseLeave={() => setHoverVisible(false)}>
				{chatVisible ? <CloseIcon /> : <AssistantIcon />}
			</div>
			<div>
				<Box className={`chat-hover ${hoverVisible ? "show" : ""}`}>
					<div style={{ padding: "10px", textAlign: "center" }}>
						<Typography variant="body1">
							{t('UI_TEXT.CHAT_WELCOME_PREFIX')} <b>{t('UI_TEXT.CHAT_WELCOME_HIGHLIGHT')}</b>
						</Typography>
					</div>
					
					<div className="chat-arrow" />
				</Box>
				
			
				
				
				<Box
					className={`chat-popup ${chatVisible ? "show" : ""}`}
					sx={{ borderBottom: "3px solid", borderColor: "primary.main" }}>
					<Tooltip title= {t('TITLES.CLOSE_CHAT')} placement="top" arrow>
						<Box
							sx={{
								position: "absolute",
								right: -10,
								top: -10,
								padding: "4px",
								borderRadius: "50%",
								backgroundColor: "white",
								zIndex: 1051,
								boxShadow: 2,
								height: "25px",
								width: "25px",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								"&:hover": {
									cursor: "pointer",
									backgroundColor: "var(--primary-main)",
									color: "white",
								},
							}}
							onClick={handleChatOpen}>
							<CloseIcon fontSize="18px" />
						</Box>
					</Tooltip>
					<Box sx={{ flex: 1, width: "100%", height: "100%" }}>
						<ChatBot />
						
					</Box>
							
					<div className="chat-arrow" />
				</Box>
			</div>
		</div>
	);
}
